import { jsx as _jsx } from "react/jsx-runtime";
import { Box, chakra } from '@chakra-ui/react';
/**
 * The bordered list every row block shares (actions to handle, briefs,
 * creators): a card frame, rows split by a hairline.
 */
export function RowList(props) {
    return (_jsx(Box, { as: "ul", m: "0", p: "0", layerStyle: "agent.card", overflow: "hidden", ...props }));
}
/** One row of a `RowList`. */
export function RowItem(props) {
    return (_jsx(Box, { as: "li", listStyleType: "none", borderBottomWidth: "1px", borderColor: "agent.divider", _last: { borderBottomWidth: '0' }, ...props }));
}
/**
 * The button filling a row: warm hover like a dashboard table row, and the
 * charcoal focus ring drawn inside the row, since the list clips its edges.
 */
export const RowButton = chakra('button', {
    base: {
        display: 'flex',
        alignItems: 'center',
        w: 'full',
        textAlign: 'left',
        cursor: 'pointer',
        transitionProperty: 'common',
        transitionDuration: 'fast',
        _hover: { bg: 'agent.hoverBg' },
        colorPalette: 'agent',
        focusVisibleRing: 'outside',
        focusRingOffset: '-2px',
    },
});
